export type ParsedRepositoryFullName = {
  owner: string;
  repo: string;
};

const REPOSITORY_FULL_NAME_PATTERN = /^([^/\s]+)\/([^/\s]+)$/;

export function parseRepositoryFullName(fullName: string): ParsedRepositoryFullName | null {
  const match = fullName.match(REPOSITORY_FULL_NAME_PATTERN);
  if (!match?.[1] || !match?.[2]) {
    return null;
  }

  return {
    owner: match[1],
    repo: match[2],
  };
}
